import { DigitalJourneyRoute } from "app/DigitalJourneyAppFlow/constants";
import { atom } from "jotai";

export interface DigitalJourneyFlowRoute {
  path: DigitalJourneyRoute;
  checkpoint?: string;
}

export const digitalJourneyFlowAtom = atom<DigitalJourneyFlowRoute[]>([]);
